<template>
  <div class="component-wrapper">
    <div class="grid-container">
      <div v-for="(image, index) in images" :key="index" class="grid-item-5-2">
        <div class="inner-grid-item">
          <div :style="{ backgroundImage: `url(${image})` }" class="image-thumbnail" @click="openLightbox(index)">
          </div>
        </div>
      </div>
    </div>

    <vue-easy-lightbox
        :hideControls="true"
        :imgs="images"
        :index="lightboxIndex"
        :visible="visible"
        @hide="handleHide"
    />
  </div>
</template>

<script>
import VueEasyLightbox from 'vue-easy-lightbox';

export default {
  name: 'AboutTitleThumbnailsComponent',
  components: {VueEasyLightbox},
  props: {
    title: {
      type: String,
    },
    lightbox: {
      type: String,
    },
    images: {
      type: Array,
    },
  },
  data() {
    return {
      visible: false,
      lightboxIndex: 0,
    };
  },
  methods: {
    openLightbox(index) {
      this.lightboxIndex = index;
      this.visible = true;
    },
    handleHide() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>

.grid-container {
  display: flex;
  flex-wrap: wrap;

  .grid-item-5-2 {
    flex: 1 0 50%; /* proportion of the available space */
    max-width: 50%;
  }

  .inner-grid-item {
    margin: $spacing-1;
    overflow: hidden;
    border-radius: 20px;

  }
}


.component-wrapper {
  position: relative;
  z-index: 9999999;

  .image-thumbnail {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    width: 100%;
    height: 150px;
    cursor: pointer;
    transition: 0.3s ease-in-out;

    &:hover {
      transform: scale(1.1);
    }
  }


}

@media screen and (min-width: 768px) {
  .grid-container {
    .grid-item-5-2 {
      flex: 1 0 20%; /* proportion of the available space */
      max-width: 20%;
    }
  }

  .component-wrapper {

    .image-thumbnail {
      height: 288px;

    }
  }

}
</style>
